import OwlCarouselElementsSliders from "../common/gallery/OwlCarouselElementsSliders";
import DataElementsEventSlider from "../common/data/DataElementsEventSlider";
const Facility = () => {
  return (
    <>
    <div className="container">
	<div className="section-full bg-white p-t80 p-b50">
            
		<div className="container">
			{/* <!-- Event post Carousel with no margin --> */}
			
				<div className="section-head">
					<h3 className="text-uppercase">Our Facility</h3>
					<div className="wt-separator-outer">
						<div className="wt-separator style-icon">
							<i className="fa fa-leaf text-black"></i>
							<span className="separator-left site-bg-primary"></span>
							<span className="separator-right site-bg-primary"></span>
						</div>                            
					</div>
				</div>
			
				<div className="section-content">
					
					<OwlCarouselElementsSliders data={DataElementsEventSlider} type={'EventSlider'}  />
				
				</div>
	
		</div>
		
	</div>
	</div>
    </>
  );
};

export default Facility;
